import React from 'react';
import { Table } from 'antd';

interface YearValuesTableProps {
    value: any;
}

const YearValuesTable: React.FC<YearValuesTableProps> = ({ value }) => {
    let parsed: Record<string, string> = {};
    try {
        parsed = typeof value === 'string' ? JSON.parse(value) : value;
    } catch {
        return <span>{String(value)}</span>;
    }

    const rows = Object.entries(parsed).map(([year, val]) => ({ year, val: String(val) }));

    if (rows.length === 0) return null;

    return (
        <Table
            size="small"
            pagination={false}
            dataSource={rows}
            rowKey="year"
            columns={[
                { title: 'Год', dataIndex: 'year', width: 80 },
                { title: 'Значение', dataIndex: 'val' },
            ]}
        />
    );
};

export default YearValuesTable;
